(function () {
  if (window.__legacyPopupLoaded) return;
  window.__legacyPopupLoaded = true;

  function onReady(fn) {
    if (document.readyState === "complete" || document.readyState === "interactive") {
      return fn();
    }
    document.addEventListener("DOMContentLoaded", fn);
  }

  onReady(function () {
    var popupRoot = document.getElementById("legacy-popup-root");
    if (!popupRoot) return;

    var overlay = popupRoot.querySelector(".legacy-popup-overlay");
    var closeBtn = popupRoot.querySelector(".legacy-close-popup");
    var cta = popupRoot.querySelector(".legacy-popup-cta");

    // Session storage key
    var sessionKey = "legacyPopupSeenThisSession";

    // Already shown this session?
    if (sessionStorage.getItem(sessionKey) === "1") {
      return;
    }

    // Show popup after delay
    setTimeout(function () {
      overlay.style.display = "flex";
      setTimeout(function () {
        overlay.classList.add("legacy-show");
      }, 20);
    }, 1500);

    // Close handler
    function closePopup() {
      overlay.classList.remove("legacy-show");
      setTimeout(function () {
        overlay.style.display = "none";
      }, 350);

      // Mark as shown this session
      sessionStorage.setItem(sessionKey, "1");
    }

    closeBtn.addEventListener("click", closePopup);

    // clicking outside modal
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closePopup();
    });

    // CTA example
    if (cta) {
      cta.addEventListener("click", function (e) {
        e.preventDefault();
        closePopup();
        window.open("#", "_blank");
      });
    }
  });
})();